import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-action-panel-title', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 'auto',
    left: 0,
    height: '37px',
    lineHeight: '37px',
    borderTop: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    paddingLeft: '18px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    color: applyColor(DesignTokens.color.font.inverse.default, '#fff'),
});

cssRule('.tb-action-panel-title-text', {
    marginRight: '37px',
    fontSize: '15px',
});

cssRule('.tb-action-panel-close', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    width: '37px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'center',
});

cssRule('.tb-action-panel-controls', {
    position: 'absolute',
    top: '39px',
    right: 0,
    bottom: 0,
    left: 0,
});

cssRule('.tb-action-panel', {
    position: 'absolute',
    top: '35px',
    right: 0,
    bottom: 0,
    left: 'auto',
});

cssRule('.tb-action-panel-placeholder-msg', {
    position: 'absolute',
    top: '35px',
    right: 0,
    bottom: 'auto',
    left: 0,
    textAlign: 'center',
    fontSize: '15px',
});

